import { render, staticRenderFns } from "./ShipmentTable.vue?vue&type=template&id=7b7ea546&scoped=true&"
import script from "./ShipmentTable.vue?vue&type=script&lang=js&"
export * from "./ShipmentTable.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentTable.vue?vue&type=style&index=0&id=7b7ea546&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7ea546",
  null
  
)

export default component.exports